'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

// global object

//

var _partialsExpandableMenu = require('partials/expandable-menu');

var _partialsExpandableMenu2 = _interopRequireDefault(_partialsExpandableMenu);

var _partialsMainnav = require('partials/mainnav');

var _partialsMainnav2 = _interopRequireDefault(_partialsMainnav);

var _partialsContact = require('partials/contact');

var _partialsContact2 = _interopRequireDefault(_partialsContact);

var _partialsGeoloc = require('partials/geoloc');

var _partialsGeoloc2 = _interopRequireDefault(_partialsGeoloc);

var _partialsLightbox = require('partials/lightbox');

var _partialsLightbox2 = _interopRequireDefault(_partialsLightbox);

var _partialsListPagination = require('partials/list-pagination');

var _partialsListPagination2 = _interopRequireDefault(_partialsListPagination);

var _partialsLoader = require('partials/loader');

var _partialsLoader2 = _interopRequireDefault(_partialsLoader);

var _partialsMediaGallery = require('partials/media-gallery');

var _partialsMediaGallery2 = _interopRequireDefault(_partialsMediaGallery);

var _partialsScrollWatcher = require('partials/scroll-watcher');

var _partialsScrollWatcher2 = _interopRequireDefault(_partialsScrollWatcher);

var _partialsSwiper = require('partials/swiper');

var _partialsSwiper2 = _interopRequireDefault(_partialsSwiper);

var _partialsGeneralAnims = require('partials/general-anims');

var _partialsGeneralAnims2 = _interopRequireDefault(_partialsGeneralAnims);

//VIEWS name = tpl name

var _viewsB4s3_home = require('views/b4s3_home');

var _viewsB4s3_home2 = _interopRequireDefault(_viewsB4s3_home);

var _viewsGalerie_d62fa = require('views/galerie_d62fa');

var _viewsGalerie_d62fa2 = _interopRequireDefault(_viewsGalerie_d62fa);

var _viewsProjet_fc0f3_services = require('views/projet_fc0f3_services');

var _viewsProjet_fc0f3_services2 = _interopRequireDefault(_viewsProjet_fc0f3_services);

var _viewsIntro = require('views/intro');

var _viewsIntro2 = _interopRequireDefault(_viewsIntro);

window.G = window.G || {};
G._html = document.querySelector('html');
G.isMobile = (0, _domClasslist2['default'])(G._html).contains('mobile');
G.isTablet = (0, _domClasslist2['default'])(G._html).contains('tablet');
G.views = {};
G.views.b4s3_home = _viewsB4s3_home2['default'];
G.views.galerie_d62fa_list = _viewsGalerie_d62fa2['default'];
G.views['le-projet_fc0f3_list'] = _viewsProjet_fc0f3_services2['default'];
//G.views.intro = intro;

//
var _body = document.querySelector('body');

document.addEventListener("DOMContentLoaded", function () {
	_pubsub2['default'].emit('document:ready');
});

_pubsub2['default'].on('body:noscroll', function () {
	(0, _domClasslist2['default'])(_body).add('no-scroll');
});
_pubsub2['default'].on('body:scroll', function () {
	(0, _domClasslist2['default'])(_body).remove('no-scroll');
});

// Global resize
var resize = function resize() {
	_pubsub2['default'].emit('resize', window.innerWidth, window.innerHeight);
};
// Only native resize listener on site
window.addEventListener('resize', resize, false);
// Can be forced from any
_pubsub2['default'].on('global-resize', resize);

var initView = function initView() {
	var tpl = _body.getAttribute('data-view');
	if (G.views[tpl]) G.views[tpl]();
};

var initOnce = function initOnce() {
	if (window.location.href.indexOf('intro') < 0) {
		(0, _partialsMainnav2['default'])();
	}
	(0, _partialsLightbox2['default'])();
	var anims = new _partialsGeneralAnims2['default']();
	//ScrollWatcher()

	var _expMenus = document.querySelectorAll('.expandable-menu');
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = _expMenus[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var el = _step.value;

			(0, _partialsExpandableMenu2['default'])(el);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator['return']) {
				_iterator['return']();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
};

var recursiveInit = function recursiveInit() {
	(0, _partialsLoader2['default'])();
	(0, _partialsContact2['default'])();
	(0, _partialsGeoloc2['default'])();
	(0, _partialsListPagination2['default'])();
	(0, _partialsMediaGallery2['default'])();
	(0, _partialsSwiper2['default'])();
	(0, _viewsIntro2['default'])();
};

_pubsub2['default'].on('document:ready', function () {
	initOnce();
	recursiveInit();
	initView();
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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